module.exports = __webpack_public_path__ + "static/media/2.76f6282b.png";